import { Box } from 'braid-design-system';
import { useState } from 'react';

import type { Partner } from 'src/types';

import { CustomAccordion } from '../CustomAccordion/CustomAccordion';

import { PartnerCard } from './PartnerCard';

import * as styles from './PartnerList.css';

interface Props {
  label: string;
  partners?: Partner[];
  defaultExpanded?: boolean;
  forceExpanded?: boolean;
  tier: Partner['tier'];
}

export const PartnerAccordion = ({
  label,
  partners,
  defaultExpanded = true,
  forceExpanded = false,
  tier,
}: Props) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  return (
    <CustomAccordion
      label={label}
      expanded={forceExpanded || expanded}
      onToggle={() => setExpanded((currVal) => !currVal)}
      disabled={partners ? partners.length === 0 : true}
      tier={tier}
    >
      <Box className={styles.cards}>
        {partners?.map((item) => (
          <PartnerCard key={item.id} partner={item} />
        ))}
      </Box>
    </CustomAccordion>
  );
};
